
export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden bg-gradient-to-br from-gray-900 via-blue-900 to-black">
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/40"></div>
      
      <div 
        className="absolute inset-0 opacity-30"
        style={{
          backgroundImage: `url(https://public.readdy.ai/ai/img_res/ed699e3c9cb37ca36848836e03a1ff98.jpg)`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      ></div>

      {[...Array(20)].map((_, i) => (
        <div
          key={i}
          className="absolute rounded-full bg-blue-400/20"
          style={{
            width: `${Math.random() * 5 + 3}px`,
            height: `${Math.random() * 5 + 3}px`,
            left: `${Math.random() * 100}%`,
            top: `${Math.random() * 100}%`,
            animation: `float ${Math.random() * 10 + 5}s ease-in-out infinite`,
          }}
        ></div>
      ))}

      <div className="relative z-10 max-w-7xl mx-auto px-8 w-full grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
        <div className="lg:col-span-3 space-y-8">
          <div className="space-y-4">
            <h2 className="text-7xl font-normal text-white leading-tight">
              Crafting Premium
            </h2>
            <h2 className="text-7xl font-bold text-white leading-tight italic" style={{ transform: 'skewY(-1deg)' }}>
              iOS Experiences
            </h2>
            <h2 className="text-5xl font-extralight text-blue-100 leading-tight">
              Since 2020
            </h2>
          </div>
          
          <p className="text-xl text-gray-300 max-w-lg leading-relaxed font-light">
            A team of experts developing modern applications for the iOS platform, enhancing user experience and mobile device security
          </p>

          <div className="absolute bottom-20 left-8 opacity-30">
            <svg width="120" height="120" viewBox="0 0 120 120" fill="none">
              <path d="M10 10 L110 110 M110 10 L10 110 M60 10 L60 110 M10 60 L110 60" stroke="#0066FF" strokeWidth="1" />
            </svg>
          </div>
        </div>

        <div className="lg:col-span-2 flex justify-center items-center">
          <div className="relative" style={{ transform: 'rotate(-15deg)' }}>
            <div className="absolute inset-0 bg-blue-500/20 blur-3xl rounded-full"></div>
            <img
              src="https://readdy.ai/api/search-image?query=modern-iphone-15-pro-mockup-displaying-sleek-vpn-app-interface-with-blue-accents-floating-on-dark-background-professional-product-photography-realistic-shadows-clean-minimalist-design-high-quality-3d-render&width=400&height=800&seq=hero-phone-001&orientation=portrait"
              alt="iOS App Interface"
              className="relative z-10 w-80 h-auto rounded-3xl shadow-2xl"
              style={{ filter: 'drop-shadow(0 40px 80px rgba(0, 102, 255, 0.4))' }}
            />
          </div>
        </div>
      </div>

      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
        }
      `}</style>
    </section>
  );
}